import { useEffect, useState } from 'react';

export const SIDEBAR_COLLAPSE_KEY = 'chariot:sidebar-collapsed';

function readStored(defaultValue: boolean): boolean {
  try {
    const stored = localStorage.getItem(SIDEBAR_COLLAPSE_KEY);
    return stored === null ? defaultValue : (JSON.parse(stored) as boolean);
  } catch {
    return defaultValue;
  }
}

export interface SidebarCollapseState {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  toggle: () => void;
}

export function useSidebarCollapse(defaultCollapsed = false): SidebarCollapseState {
  const [collapsed, setCollapsed] = useState(() => readStored(defaultCollapsed));

  useEffect(() => {
    try {
      localStorage.setItem(SIDEBAR_COLLAPSE_KEY, JSON.stringify(collapsed));
    } catch {
      // Storage throws in private windows and under blocked-site-data settings.
    }
  }, [collapsed]);

  return {
    collapsed,
    setCollapsed,
    toggle: () => {
      setCollapsed((current) => !current);
    },
  };
}
